'use strict';

var log = require('../../log/Log').channel('AveoUtility');
var ResizeSensor = require('css-element-queries/src/ResizeSensor');
var sutl = require('../../sutl/Sutl');

angular
    .module('aveoUtility', ['ionic'])

    // The aveoOnFirst directive triggers a callback ('onFirst') on the scope
    // of the element to which it is applied when the $first condition for an
    // ng-repeat is true.

    .directive('aveoOnFirst', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                if (scope.$first && angular.isDefined(scope.onFirst)) {
                    scope.onFirst();
                }
            },
        };
    })

    // The aveoOnLast directive triggers a callback ('onLast') on the scope
    // of the element to which it is applied when the $last condition for an
    // ng-repeat is true.

    .directive('aveoOnLast', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                if (scope.$last && angular.isDefined(scope.onLast)) {
                    scope.onLast();
                }
            },
        };
    })

    // The aveoSpinner directive selects between:
    // 1) An animated .png spinner
    // 2) A static icon
    // 3) An animated .svg spinner (ion-spinner)
    // The ion-spinner and to a lesser extent the animated .png cause a memory leak
    // on the Mimo platform, so this provides a workaround for the problem.
    // On the Mimo platform, we use the .png for short-running operations
    // and the icon for long-running operations. On all other platforms we use the
    // ion-spinner.
    .directive('aveoSpinner', [
        'DeviceService',
        function (DeviceService) {
            return {
                restrict: 'E',
                scope: {
                    spinnerClass: '<spinnerClass',
                    spinnerLight: '<spinnerLight',
                    spinnerLongRunning: '<spinnerLongRunning',
                },
                replace: true,
                templateUrl: 'aveoSpinner.html',
                link: function (scope, element, attrs) {
                    var unwatchSpinnerType = scope.$watch(function () {
                        if (DeviceService.getDeviceManagerName() === 'mimo') {
                            if (scope.spinnerLongRunning) {
                                scope.spinnerType = 'icon';
                            } else {
                                scope.spinnerType = 'image';
                            }
                        } else {
                            scope.spinnerType = 'ionic';
                        }
                        return scope.spinnerType;
                    });
                    scope.$on('destroy', function () {
                        unwatchSpinnerType();
                    });
                },
            };
        },
    ])

    // The addAttributes directive takes an argument "attributes" which evaluates
    // to an object literal whose keys will be arguments for .find(), searching
    // all child elements.  The values of the object are objects whose keys
    // are attribute names and whose values are attribute values to be applied
    // to each found element.
    // e.g.
    // <add-attributes attributes="{ 'input': { 'autocapitalize': 'off' } }"
    //    <some-elements>...</some-elements>
    // </add-attributes>

    .directive('addAttributes', function () {
        return {
            restrict: 'E',
            scope: {
                attrs: '@attributes',
            },
            link: function (scope, element, attrs) {
                var attrMap = scope.$eval(scope.attrs);
                for (var elKey in attrMap) {
                    if (attrMap.hasOwnProperty(elKey)) {
                        var el = element.find(elKey);
                        var elAttrs = attrMap[elKey];
                        for (var attrKey in elAttrs) {
                            if (elAttrs.hasOwnProperty(attrKey)) {
                                el.attr(attrKey, elAttrs[attrKey]);
                            }
                        }
                    }
                }
            },
        };
    })

    // The addClasses directive takes an argument "classes" which evaluates
    // to an object literal whose keys will be arguments for .find(), searching
    // all child elements.  The values of the object are strings which
    // are space-delimited class names to be added to each found element.
    // e.g.
    // <add-classes attributes="{ 'a': 'blue button large' }"
    //    <some-elements>...</some-elements>
    // </add-classes>

    .directive('addClasses', function () {
        return {
            restrict: 'E',
            scope: {
                classes: '@classes',
            },
            link: function (scope, element, attrs) {
                var classMap = scope.$eval(scope.classes);
                for (var elKey in classMap) {
                    if (classMap.hasOwnProperty(elKey)) {
                        var el = element.find(elKey);
                        var elClasses = classMap[elKey];
                        el.addClass(elClasses);
                    }
                }
            },
        };
    })

    // Specifies a CSS class that will be added/removed to the element on which
    // this keyboardVisibleClass is added based on whether the native keyboard
    // is visible or hidden.

    .directive('keyboardVisibleClass', [
        '$window',
        function ($window) {
            return {
                restrict: 'A',
                scope: {
                    visibleClass: '@keyboardVisibleClass',
                },
                link: function (scope, element, attrs) {
                    $window.addEventListener('native.keyboardshow', onKeyboardShow);
                    $window.addEventListener('native.keyboardhide', onKeyboardHide);
                    scope.$on('$destroy', function () {
                        $window.removeEventListener('native.keyboardshow', onKeyboardShow);
                        $window.removeEventListener('native.keyboardhide', onKeyboardHide);
                    });

                    function onKeyboardShow() {
                        element.addClass(scope.visibleClass);
                    }

                    function onKeyboardHide() {
                        element.removeClass(scope.visibleClass);
                    }
                },
            };
        },
    ])

    // The syncFocusWith directive allows an element to have a scope or
    // controller property synced to the focus of the element, such that the
    // controller can then change the focus by changing the value of the
    // property to true (focused) or false (blurred).  A syncFocusTarget can
    // also be used to specify a child element of the element on which the
    // syncFocusWith directive occurs.  If omitted, the element on which the
    // directive occurs will have its focus synced.

    .directive('syncFocusWith', [
        '$timeout',
        function ($timeout) {
            return {
                restrict: 'A',
                scope: {
                    focusValue: '=syncFocusWith',
                    focusTarget: '@syncFocusTarget',
                },
                link: function (scope, element, attrs) {
                    scope.$watch('focusValue', function (currentValue, previousValue) {
                        var target = scope.focusTarget ? element.find(scope.focusTarget) : element;
                        if (target.length > 0) {
                            if (currentValue) {
                                target[0].focus();
                            } else {
                                target[0].blur();
                            }
                        }
                    });
                },
            };
        },
    ])

    // Service allowing focusing of an element by id.  Used by eventFocus
    // directive.
    .factory('focus', [
        '$timeout',
        '$window',
        function ($timeout, $window) {
            return function (id) {
                // timeout makes sure that it is invoked after any other event has been triggered.
                // e.g. click events that need to run before the focus or
                // inputs elements that are in a disabled state but are enabled when those events
                // are triggered.
                $timeout(function () {
                    var element = $window.document.getElementById(id);
                    if (element) {
                        element.focus();
                    }
                });
            };
        },
    ])

    // The eventFocus directive defines an event on the declaring element
    // which will trigger the focusing of another element by an id determined by
    // the expression supplied in the eventFocusId attribute.
    .directive('eventFocus', [
        'focus',
        function (focus) {
            return function (scope, elem, attr) {
                elem.on(attr.eventFocus, function (evt) {
                    focus(scope.$eval(attr.eventFocusId));
                    return true;
                });

                // Removes bound events in the element itself
                // when the scope is destroyed
                scope.$on('$destroy', function () {
                    elem.off(attr.eventFocus);
                });
            };
        },
    ])

    // Directive to prevent an element from losing focus as long as the trigger
    // expression is true. This is useful for keeping the soft keyboard open,
    // while certain events such as clicks take place.
    .directive('stayFocused', [
        '$timeout',
        function ($timeout) {
            return {
                scope: {
                    id: '@focusElementId',
                    trigger: '=stayFocused',
                },
                link: function (scope, element) {
                    var focusEl = null;
                    // TODO: is there a better way to do this without a watch?
                    scope.$watch('trigger', function (value) {
                        if (focusEl === null) {
                            focusEl = angular.element(document.getElementById(scope.id));
                        } else {
                            if (value === true) {
                                focusEl.on('blur', doFocus);
                            } else {
                                focusEl.off('blur', doFocus);
                            }
                        }
                    });

                    scope.$on('$destroy', function () {
                        if (focusEl !== null) {
                            focusEl.off('blur', doFocus);
                            focusEl = null;
                        }
                    });

                    function doFocus() {
                        var el = document.getElementById(scope.id);
                        if (el) el.focus();
                    }
                },
            };
        },
    ])

    // The touchRepeat directive augments an Ionic onTouch directive by
    // providing repeat capability after a set hold time for a touch.  The
    // touchRepeat directive can take an optional attribute to configure the
    // interval between repeat actions:
    //
    // touch-repeat="200"
    //
    // The hold time before repeat can also be configured with another optional
    // attribute, touchRepeatHold:
    //
    // touch-repeat-hold="700"
    //
    // The expression in the onTouch attribute is the action that will be
    // repeated by the touchRepeat. An alternative expression can be executed
    // when the touch is being repeated which is specified in touchOnRepeat.
    // This will be executed instead of the onTouch expression.
    //
    // touch-on-repeat="onTouchRepeating()"

    .directive('touchRepeat', [
        '$timeout',
        '$interval',
        function ($timeout, $interval) {
            return {
                restrict: 'A',
                scope: {
                    action: '&onTouch',
                    repeatIntervalDuration: '&touchRepeat',
                    holdTimeoutDuration: '&touchRepeatHold',
                    repeatAction: '&touchOnRepeat',
                },
                link: function (scope, element, attrs) {
                    var INACTIVE = 0,
                        TOUCH = 1,
                        HOLD = 2,
                        REPEAT = 3;
                    var repeatState = INACTIVE;
                    var holdTimeout = null;
                    var repeatInterval = null;
                    var touchGesture = null;
                    var releaseGesture = null;

                    touchGesture = ionic.EventController.onGesture('touch', onTouch, element[0]);
                    releaseGesture = ionic.EventController.onGesture(
                        'release',
                        onRelease,
                        element[0]
                    );

                    if (attrs.touchRepeat === '') {
                        scope.repeatIntervalDuration = 100;
                    }

                    if (!angular.isDefined(attrs.touchRepeatHold) || attrs.touchRepeatHold === '') {
                        scope.holdTimeoutDuration = 500;
                    }

                    if (!angular.isDefined(attrs.touchOnRepeat) || attrs.touchOnRepeat === '') {
                        scope.repeatAction = null;
                    }

                    scope.$on('$destroy', function () {
                        endRepeat();
                        ionic.EventController.offGesture(touchGesture, 'touch', onTouch);
                        ionic.EventController.offGesture(releaseGesture, 'release', onRelease);
                    });

                    function onTouch(event) {
                        repeatState = TOUCH;
                        holdTimeout = $timeout(function () {
                            repeatState = HOLD;
                            startRepeat();
                        }, scope.holdTimeoutDuration);
                    }

                    function onRelease(event) {
                        endRepeat(element[0]);
                    }

                    function startRepeat() {
                        if (repeatInterval) return;
                        repeatInterval = $interval(function () {
                            if (repeatState === HOLD) {
                                repeatState = REPEAT;
                            }
                            if (repeatState === REPEAT) {
                                if (scope.repeatAction) {
                                    // Invoke the alternate touch repeat action
                                    scope.repeatAction(scope);
                                } else if (scope.action) {
                                    // Invoke the touch action
                                    scope.action(scope);
                                }
                                // Dispatch an event so other components can know we
                                // are repeating
                                var repeatEvent = new CustomEvent('touchrepeat', {
                                    bubbles: true,
                                    cancelable: true,
                                });
                                element[0].dispatchEvent(repeatEvent);
                            }
                        }, parseInt(scope.repeatIntervalDuration, 10));
                    }

                    function endRepeat(element) {
                        repeatState = INACTIVE;
                        if (holdTimeout) {
                            $timeout.cancel(holdTimeout);
                            holdTimeout = null;
                        }
                        if (repeatInterval) {
                            $interval.cancel(repeatInterval);
                            repeatInterval = null;
                        }
                    }
                }, // link
            };
        },
    ]) // directive

    .directive('scrollShadow', [
        '$timeout',
        function ($timeout) {
            return {
                restrict: 'A',
                link: function (scope, elem, attr) {
                    var shadowClassTop = 'scroll-shadow-top';
                    var shadowClassBottom = 'scroll-shadow-bottom';
                    var resizeSensor = null;
                    var resizeObserver = null;
                    if (attr.shadowClassTop) {
                        shadowClassTop = attr.shadowClassTop;
                    }
                    if (attr.shadowClassBottom) {
                        shadowClassBottom = attr.shadowClassBottom;
                    }
                    elem.on('scroll', function (evt) {
                        updateScrollShadows();
                        return true;
                    });

                    if (typeof window.ResizeObserver === 'function') {
                        resizeObserver = new window.ResizeObserver(updateScrollShadows);
                        resizeObserver.observe(elem[0]);
                    } else {
                        resizeSensor = new ResizeSensor(elem[0], updateScrollShadows);
                    }

                    var unwatchCollection = null;
                    if (attr.scrollShadow) {
                        if (attr.scrollShadowMultiple) {
                            unwatchCollection = [];
                            var collections = scope.$eval(attr.scrollShadow);
                            for (var i = 0; i < collections.length; i++) {
                                unwatchCollection.push(
                                    watchCollection(createWatchFunction(collections, i))
                                );
                            }
                        } else {
                            unwatchCollection = watchCollection(attr.scrollShadow);
                        }
                    }

                    // Removes bound events in the element itself
                    // when the scope is destroyed
                    scope.$on('$destroy', function () {
                        if (resizeSensor) {
                            resizeSensor.detach();
                            resizeSensor = null;
                        }
                        if (resizeObserver) {
                            resizeObserver.unobserve(elem[0]);
                            resizeObserver = null;
                        }
                        elem.off('scroll');
                        if (unwatchCollection) {
                            if (attr.scrollShadowMultiple) {
                                for (var i = 0; i < unwatchCollection.length; i++) {
                                    unwatchCollection[i]();
                                }
                            } else {
                                unwatchCollection();
                            }
                        }
                    });

                    function createWatchFunction(collections, index) {
                        return function () {
                            return collections[index];
                        };
                    }

                    function updateScrollShadows() {
                        // Look for whether ion-scroll is updating a tranform on the
                        // child scroll object, and if so, use y value of the transform
                        // to calculate the scrollTop value. This case supports the
                        // browser platform.
                        var transform =
                            elem[0].children.length > 0 &&
                            elem[0].children[0].classList.contains('scroll')
                                ? elem[0].children[0].style.transform
                                : '';
                        var regEx = /translate3d\(-?\d+px,\s*(-?\d+)px,\s*-?\d+px\)/;
                        var matches = regEx.exec(transform);
                        var scrollTop = 0;
                        var scrollOffset;
                        if (matches && matches.length > 1) {
                            scrollTop = 0 - parseInt(matches[1]);
                            // fudge factor for scrolling with translate3d
                            scrollOffset = 2;
                        } else {
                            scrollTop = elem[0].scrollTop;
                            scrollOffset = 0;
                        }

                        if (scrollTop > 0) {
                            elem.addClass(shadowClassTop);
                        } else {
                            elem.removeClass(shadowClassTop);
                        }
                        if (
                            elem[0].scrollHeight - scrollTop - scrollOffset <=
                            elem[0].clientHeight
                        ) {
                            elem.removeClass(shadowClassBottom);
                        } else {
                            elem.addClass(shadowClassBottom);
                        }
                    }

                    function watchCollection(collection) {
                        return scope.$watchCollection(collection, function () {
                            elem.removeClass(shadowClassTop);
                            elem.removeClass(shadowClassBottom);
                            // delay the initial update to catch small
                            // layout changes
                            $timeout(function () {
                                updateScrollShadows();
                            }, 500);
                        });
                    }
                },
            };
        },
    ])

    .directive('aveoTabs', [
        '$timeout',
        function ($timeout) {
            return {
                restrict: 'E',
                transclude: true,
                scope: {
                    delegateHandle: '@delegateHandle',
                    selected: '=?selected',
                    selectedData: '=?selectedData',
                    onTabCountChanged: '<onTabCountChanged',
                    onTabSelected: '<onTabSelected',
                },
                template:
                    '<button type="button"' +
                    'class="aveo-tab-scroll-button aveo-tab-scroll-button-left icon ion-ios-arrow-left"' +
                    'ng-click="onScrollClicked(-1)" ng-if="showScrollButton(\'left\')"></button>' +
                    '<div class="aveo-tab-headers">' +
                    '<ng-transclude></ng-transclude>' +
                    '</div>' +
                    '<button type="button"' +
                    'class="aveo-tab-scroll-button aveo-tab-scroll-button-right icon ion-ios-arrow-right"' +
                    'ng-click="onScrollClicked(1)" ng-if="showScrollButton(\'right\')"></button>',
                link: function (scope, elem, attr) {
                    var showScrollButton = {
                        left: false,
                        right: false,
                    };
                    var resizeSensor = null;
                    var resizeObserver = null;
                    var tabsEl = elem.children();
                    tabsEl.on('scroll', function (evt) {
                        updateScrollButtons();
                        return true;
                    });
                    scope.el = elem;
                    scope.tabsEl = tabsEl;

                    if (typeof window.ResizeObserver === 'function') {
                        resizeObserver = new window.ResizeObserver(updateScrollButtons);
                        resizeObserver.observe(tabsEl[0]);
                    } else {
                        resizeSensor = new ResizeSensor(tabsEl[0], updateScrollButtons);
                    }

                    // Removes bound events in the element itself
                    // when the scope is destroyed
                    scope.$on('$destroy', function () {
                        if (resizeSensor) {
                            resizeSensor.detach();
                            resizeSensor = null;
                        }
                        if (resizeObserver) {
                            resizeObserver.unobserve(tabsEl[0]);
                            resizeObserver = null;
                        }
                        tabsEl.off('scroll');
                    });

                    scope.onScrollClicked = function (scroll) {
                        var scrollButton = scope.el.find('button');
                        var scrollOffset = tabsEl[0].clientWidth - 2 * scrollButton[0].clientWidth;
                        var left = Math.min(
                            Math.max(tabsEl[0].scrollLeft + scroll * scrollOffset, 0),
                            tabsEl[0].scrollWidth - tabsEl[0].clientWidth
                        );
                        scope.scrollTabs(tabsEl[0], left);
                    };

                    scope.scrollTabs = function (tabsEl, left) {
                        var scrollOptions = { left: left, behavior: 'smooth' };
                        tabsEl.scroll(scrollOptions);
                        if (left === tabsEl.scrollWidth - tabsEl.clientWidth) {
                            // Chrome seems to have a bug where smooth scrolling to the
                            // rightmost scroll position stops one pixel short. Send
                            // another scroll request without the smooth behavior to
                            // scroll the last pixel
                            $timeout(function () {
                                if (tabsEl && angular.isFunction(tabsEl.scroll)) {
                                    tabsEl.scroll({ left: left });
                                }
                            }, 200);
                        }
                    };

                    scope.showScrollButton = function (button) {
                        if (!showScrollButton.hasOwnProperty(button)) return false;
                        return showScrollButton[button];
                    };

                    function updateScrollButtons() {
                        showScrollButton.left = tabsEl[0].scrollLeft > 0;
                        showScrollButton.right =
                            tabsEl[0].scrollWidth - tabsEl[0].scrollLeft - 1 >
                            tabsEl[0].clientWidth;
                    }
                },
                controllerAs: 'aveoTabs',
                controller: [
                    '$scope',
                    '$element',
                    '$attrs',
                    'aveoTabsDelegate',
                    function ($scope, $element, $attrs, aveoTabsDelegate) {
                        var vm = this;
                        var zIndexBase = 40;
                        vm.tabs = [];
                        $scope.selected = null;
                        $scope.selectedData = null;

                        var unregisterInstance = aveoTabsDelegate._registerInstance(
                            vm,
                            $attrs.delegateHandle
                        );
                        $scope.$on('$destroy', unregisterInstance);

                        vm.addTab = function (tab) {
                            vm.tabs.push(tab);
                            tab.$tabIndex = vm.tabs.length - 1;
                            for (var i = 0; i < vm.tabs.length; i++) {
                                if (vm.tabs[i].$zIndex) {
                                    vm.tabs[i].$zIndex++;
                                } else {
                                    vm.tabs[i].$zIndex = zIndexBase;
                                }
                            }
                            if ($scope.onTabCountChanged) $scope.onTabCountChanged(vm.tabs.length);
                        };

                        vm.removeTab = function (tab) {
                            var foundIndex = vm.tabs.findIndex(function (val) {
                                return tab === val;
                            });
                            if (foundIndex !== -1) {
                                vm.tabs.splice(foundIndex, 1);
                                if ($scope.onTabCountChanged)
                                    $scope.onTabCountChanged(vm.tabs.length);
                            }
                        };

                        vm.selectTab = function (tab) {
                            for (var i = 0; i < vm.tabs.length; i++) {
                                if (vm.tabs[i] === tab) {
                                    vm.tabs[i].onTabSelected();
                                    break;
                                }
                            }
                        };

                        vm.selectTabWithData = function (tabData) {
                            for (var i = 0; i < vm.tabs.length; i++) {
                                if (vm.tabs[i].tabData === tabData) {
                                    vm.tabs[i].onTabSelected();
                                    break;
                                }
                            }
                        };

                        vm.onTabSelected = function (tab, element) {
                            $scope.selected = tab;
                            $scope.selectedData = tab.tabData;
                            var selectedZIndex = zIndexBase + vm.tabs.length - 1;
                            for (var i = 0; i < vm.tabs.length; i++) {
                                if (vm.tabs[i] === $scope.selected) {
                                    vm.tabs[i].$zIndex = selectedZIndex;
                                    vm.tabs[i].$selected = true;
                                    if ($scope.onTabSelected) $scope.onTabSelected($scope.selected);
                                } else {
                                    if (i < $scope.selected.$tabIndex) {
                                        vm.tabs[i].$zIndex = selectedZIndex - i;
                                    } else {
                                        vm.tabs[i].$zIndex =
                                            selectedZIndex + $scope.selected.$tabIndex - i;
                                    }
                                    vm.tabs[i].$selected = false;
                                }
                            }
                            if (element && element.length > 0) {
                                var scrollButton = $scope.el.find('button');
                                var scrollButtonLeftWidth = $scope.showScrollButton('left')
                                    ? scrollButton[0].clientWidth
                                    : 0;
                                var scrollButtonRightWidth = $scope.showScrollButton('right')
                                    ? scrollButton[0].clientWidth
                                    : 0;
                                var left = null;
                                if (
                                    element[0].offsetLeft <
                                    $scope.tabsEl[0].scrollLeft + scrollButtonLeftWidth
                                ) {
                                    left = element[0].offsetLeft - 2 * scrollButtonLeftWidth;
                                } else if (
                                    element[0].offsetLeft -
                                        $scope.tabsEl[0].scrollLeft +
                                        element[0].clientWidth >
                                    $scope.tabsEl[0].clientWidth - scrollButtonRightWidth
                                ) {
                                    left = Math.min(
                                        element[0].offsetLeft +
                                            element[0].clientWidth -
                                            $scope.tabsEl[0].clientWidth +
                                            2 * scrollButtonRightWidth,
                                        $scope.tabsEl[0].scrollWidth - $scope.tabsEl[0].clientWidth
                                    );
                                }
                                if (left !== null) $scope.scrollTabs($scope.tabsEl[0], left);
                            }
                        };
                    },
                ],
            };
        },
    ])

    .directive('aveoTab', function () {
        return {
            restrict: 'E',
            transclude: true,
            replace: true,
            scope: {
                tabData: '=tabData',
            },
            require: '^aveoTabs',
            template:
                '<div class="aveo-tab-header"' +
                'ng-class="{ \'selected\': $selected }"' +
                'id="{{\'tab-index-\' + $tabIndex}}"' +
                'ng-click="onTabSelected()"' +
                'ng-style="{ \'z-index\': $zIndex }">' +
                '<ng-transclude></ng-transclude>' +
                '</div',
            link: function (scope, element, attrs, tabsCtrl) {
                scope.$on('$destroy', function () {
                    tabsCtrl.removeTab(scope);
                });
                scope.onTabSelected = function () {
                    tabsCtrl.onTabSelected(scope, element);
                };
                tabsCtrl.addTab(scope);
            },
        };
    })

    .directive('aveoTabBackground', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            template:
                '<div class="aveo-tab-header aveo-tab-background"' +
                'ng-style="{ \'z-index\': 0 }">' +
                '</div',
        };
    })

    // create a delegate service to access some controller methods programmatically
    .service('aveoTabsDelegate', ionic.DelegateService(['selectTab', 'selectTabWithData']))

    // Filter to return objects with a specified number of properties:
    //  1) If 'property' is specified, that property of the object will be checked
    //     to see if its property count matches 'count'.
    //  2) If 'property' is null, the object itself will be checked to see if its
    //     property count matches 'count'.
    .filter('objectPropertyCount', function () {
        return function (items, property, count) {
            var filtered = [];
            angular.forEach(items, function (item, key) {
                if (Object.keys(property === null ? item : item[property]).length === count) {
                    filtered.push(item);
                }
            });
            return filtered;
        };
    })

    .factory('IosTouchEventService', [
        '$timeout',
        function ($timeout) {
            log.info('initializing');

            // This service provides a method to wrap onTouch/onRelease event handlers
            // to filter out extra mousedown/mouseup events that some iOS versions
            // generate. The version of Hammer.js built into Ionic v1 responds to both
            // touch and mouse events to ensure that it functions on different platforms
            // and this causes double-firing of onTouch/onRelease handlers on iOS. The
            // wrapped versions of the functions use a timeout (which can be configured
            // by the caller if desired) to ignore mouse events that occur shortly after
            // touch events. The caller can optionally also supply a thisArg that will
            // be used as 'this' when calling the user supplied callbacks.

            return {
                wrapHandlers: wrapHandlers,
            };

            function wrapHandlers(onTouchHandler, onReleaseHandler, timeoutMs, thisArg) {
                var touchTimeout = null;
                if (!angular.isDefined(timeoutMs)) timeoutMs = 500;
                if (!angular.isDefined(thisArg)) thisArg = null;
                return {
                    onRelease: onRelease,
                    onTouch: onTouch,
                };

                function onRelease($event) {
                    var returnVal;
                    if (
                        sutl.getNode($event, 'gesture.pointerType') === 'mouse' &&
                        touchTimeout !== null
                    ) {
                        // log.debug('Ignoring mouse ' +
                        //     sutl.getNode($event, 'gesture.eventType') +
                        //     ' event that was synthesized after touchend');
                        return;
                    }
                    if (onReleaseHandler) returnVal = onReleaseHandler.apply(thisArg, arguments);
                    if (
                        sutl.getNode($event, 'gesture.pointerType') === 'touch' &&
                        sutl.getNode($event, 'gesture.eventType') === 'end'
                    ) {
                        if (touchTimeout !== null) {
                            $timeout.cancel(touchTimeout);
                        }
                        touchTimeout = $timeout(function () {
                            touchTimeout = null;
                        }, timeoutMs);
                    }
                    return returnVal;
                }

                function onTouch($event) {
                    if (
                        sutl.getNode($event, 'gesture.pointerType') === 'mouse' &&
                        touchTimeout !== null
                    ) {
                        // log.debug('Ignoring mouse ' +
                        //     sutl.getNode($event, 'gesture.eventType') +
                        //     ' event that was synthesized after touchend');
                        return;
                    }
                    if (onTouchHandler) return onTouchHandler.apply(thisArg, arguments);
                }
            }
        },
    ]);
